var map = {
	"./bounce/blocks": 2429,
	"./calc/blocks": 2430,
	"./craft/agent/blocks": 2432,
	"./craft/code-connection/blocks": 2433,
	"./craft/designer/blocks": 2300,
	"./craft/simple/blocks": 2431,
	"./dance/blocks": 2024,
	"./eval/blocks": 2434,
	"./flappy/blocks": 2435,
	"./jigsaw/blocks": 2441,
	"./maze/blocks": 2447,
	"./p5lab/spritelab/blocks": 1618,
	"./sites/studio/pages/blocks": 2459,
	"./studio/blocks": 2309,
	"./turtle/blocks": 2455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2873;